import PinCodeSignIn from '../../../components/PinCodeSignIn'

const DriverSignIn = () => {
  return <PinCodeSignIn />
}

export default DriverSignIn
